/**
 * ScrollLock
 * Locks the scroll of the body while rendered
 */
const ScrollLock: React.FC = () => {
  return <style>{`body {overflow: hidden;}`}</style>;
};

export default ScrollLock;
